import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=5e72cf19&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=5e72cf19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72cf19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e72cf19')) {
      api.createRecord('5e72cf19', component.options)
    } else {
      api.reload('5e72cf19', component.options)
    }
    module.hot.accept("./Toolbar.vue?vue&type=template&id=5e72cf19&scoped=true", function () {
      api.rerender('5e72cf19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/Toolbar.vue"
export default component.exports